// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const GoalLeaf = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
		width="1em"
		height="1em"
		viewBox="0 0 96 96"
		{...props}
	>
		<use fill="#FFF" fillRule="evenodd" xlinkHref="#GoalLeaf_tsx__goal-onboarding-leaf-a" />
		<path
			d="M26.089 66.093a60.214 60.214 0 0 1 4.372-8.153c4.213-6.608 9.394-12.262 16.98-19.117 1.36-1.229 9.272-8.167 11.37-10.108a1.75 1.75 0 0 1 2.377 2.57c-2.14 1.98-10.073 8.936-11.4 10.135-15.97 14.43-23.67 26.508-25.043 44.712a1.75 1.75 0 0 1-3.49-.264c.437-5.792 1.578-11.149 3.393-16.173-9.649-9.937-11.21-24.23-3.506-34.479 3.401-4.524 7.444-7.717 12.346-10.028 3.728-1.757 7.134-2.772 13.594-4.297l.817-.192c12.752-3.002 17.98-5.297 23.28-11.804.85-1.043 2.508-.778 2.99.477 6.882 17.9 3.877 35.355-9.24 50.069-8.491 9.526-25.285 15.428-33.265 12.649a1.75 1.75 0 1 1 1.152-3.306c6.52 2.272 21.885-3.128 29.5-11.672 11.567-12.974 14.672-28.043 9.557-43.751-2.862 2.903-6.148 5.084-9.985 6.768-3.567 1.567-6.542 2.413-13.187 3.977l-.815.192c-12.713 3-18.444 5.701-23.946 13.022-6.336 8.428-5.377 20.118 2.149 28.773Z"
			fillRule="evenodd"
		/>
	</svg>
);
export default GoalLeaf;
